<form class="k-form" [formGroup]="formGroup.get('meta')" [ngSwitch]="data.valueType">
  <circ-metadata-boolean *ngSwitchCase="'boolean'" [data]="data" [formGroup]="formGroup.get('meta')"></circ-metadata-boolean>
  <circ-metadata-string *ngSwitchCase="'string'" [data]="data" [formGroup]="formGroup.get('meta')"></circ-metadata-string>
  <circ-metadata-number *ngSwitchCase="'number'" [data]="data" [formGroup]="formGroup.get('meta')"></circ-metadata-number>
  <circ-metadata-choice *ngSwitchCase="'choice'" [data]="data" [formGroup]="formGroup.get('meta')"></circ-metadata-choice>
  <circ-metadata-date *ngSwitchCase="'date'" [data]="data" [formGroup]="formGroup.get('meta')"></circ-metadata-date>
  <span *ngSwitchDefault>Unbekannter Metadaten Typ - '{{data.valueType}'.}</span>
</form>
